import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { MatPaginator, MatSort } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf } from 'rxjs/observable/of';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';
import { catchError, map, switchMap } from 'rxjs/operators';
import { merge } from 'rxjs/observable/merge';
import { fromEvent } from 'rxjs/observable/fromEvent';

import { VehiclesGroupsService } from '../../../_services/vehicles-groups.service';
import { RepairerDataSource } from './repairers.datasource';
import { IVehicleGroupForUserListRow } from '../../../_models/vehicle';
import { PaginationParams } from '../../../_models/generic';
import { AuthenticationService } from 'app/_services';
import { RepairerService } from 'app/_services/repairers.service';


@Component({
  selector: 'app-dl-multi-select-repairers',
  templateUrl: './dl-multi-select-repairers.component.html',
  styleUrls: ['./dl-multi-select-repairers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlMultiSelectRepairerComponent implements OnInit {

  // selectedGroups: Array<IMultiSelectVehicleRow> = [];

  filter = '';
  dataSource: RepairerDataSource;
  displayedColumns: string[] = ['name', 'id'];
  public defaultPageSize: number = 50;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() repairer = NaN;
  @Input() labelText: string;
  @Output() outputSelectedRepairer = new EventEmitter<number>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('multiSelectVGSearch') tableSearchInput: ElementRef;

  constructor(private _repairerService: RepairerService) { }

  ngOnInit() {
    // Create new instance of datasource
    this.dataSource = new RepairerDataSource(this._repairerService);
    // Get first page of data
    this.loadInitialVehicles();
  }

  ngAfterViewInit() {
    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap((event: Event) => {
          const filterValue = (event.target as HTMLInputElement).value;
          this.filter = filterValue.trim().toLowerCase();
        })
      )
      .subscribe();
  }

  public selectItem(item: IVehicleGroupForUserListRow) {
    this.repairer = item.id;
    this.outputSelectedRepairer.emit(item.id);
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
  }

  private loadInitialVehicles() {
    let { user } = JSON.parse(localStorage.getItem('currentUser')) || { user: null };
    const custId = user.customers[0] ? user.customers[0].id : 0
    this.dataSource.loadCustomerRepairer(custId);
  }

}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-repairers/dl-multi-select-repairers.component.ts